import type { CardItem } from "@/lib/blocks";
import { cn } from "@/lib/utils";
import { Markdown } from "@/components/Markdown";
import { TONES, toneOf } from "./tone";

export function Cards({ props }: { props: Record<string, unknown> }) {
  const columns = props.columns === 3 || props.columns === "3" ? 3 : 2;
  const items: CardItem[] = Array.isArray(props.items)
    ? (props.items as unknown[]).map((raw) => {
        const o = (raw && typeof raw === "object" ? raw : { title: String(raw) }) as CardItem;
        return {
          title: String(o.title ?? ""),
          body: o.body !== undefined && o.body !== null ? String(o.body) : undefined,
          tone: o.tone ? toneOf(o.tone) : undefined,
        };
      })
    : [];

  if (items.length === 0) {
    return <div className="rounded-xl border border-dashed px-4 py-3 text-sm text-muted-foreground">No cards</div>;
  }

  return (
    <div className={cn("grid gap-3", columns === 3 ? "sm:grid-cols-2 lg:grid-cols-3" : "sm:grid-cols-2")}>
      {items.map((c, i) => {
        const t = c.tone ? TONES[c.tone] : null;
        return (
          <article key={i} className="relative overflow-hidden rounded-xl border bg-card px-4 py-3.5">
            {t && <span className={cn("absolute inset-y-0 left-0 w-1", t.stripe)} aria-hidden />}
            <h4 className="text-[0.95rem] font-semibold leading-snug">
              <Markdown inline>{c.title}</Markdown>
            </h4>
            {c.body && (
              <div className="mt-1.5 text-sm text-muted-foreground">
                <Markdown compact>{c.body}</Markdown>
              </div>
            )}
          </article>
        );
      })}
    </div>
  );
}
